import { createApi } from "@reduxjs/toolkit/dist/query/react";
import { baseQueryWithAccount } from "@/redux/baseQuery";
import { Profile, ProfileOptions } from "@/redux/slices/profile/types";
import { transformProfile, transformProfileOptions } from "./helpers";
import { UpdateProfileParams } from "./types";

export const profileApi = createApi({
  reducerPath: "profileApi",
  baseQuery: baseQueryWithAccount("profile"),
  endpoints: (builder) => ({
    getProfile: builder.query<Profile, void>({
      query: () => "",
      transformResponse: transformProfile,
      providesTags: ["Profile"],
    }),
    getProfileOptions: builder.query<ProfileOptions, void>({
      query: () => `/options`,
      transformResponse: transformProfileOptions,
    }),
    updateProfile: builder.mutation<void, UpdateProfileParams & { accountId?: string }>({
      // `accountId` (optional) is lifted out of the body so baseQueryWithAccount can target that
      // account's URL — e.g. an operator editing a managed client. The rest is the PUT body.
      query: ({ accountId, ...body }) => ({
        url: "",
        method: "PUT",
        body,
        accountId,
      }),
      invalidatesTags: ["Profile"],
    }),
    updateAvatar: builder.mutation<void, FormData>({
      query: (body) => ({
        url: "/avatar",
        method: "POST",
        body,
      }),
    }),
    deleteAvatar: builder.mutation<void, void>({
      query: () => ({
        url: "/avatar",
        method: "DELETE",
      }),
    }),
  }),
  tagTypes: ["Profile"],
});

export const { useUpdateAvatarMutation, useDeleteAvatarMutation, useLazyGetProfileQuery, useGetProfileQuery, useGetProfileOptionsQuery, useUpdateProfileMutation } =
  profileApi;
